// extracted by mini-css-extract-plugin
export var formTitle = "k_D";